import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import CurrentCompanySyncChecker from 'components/currentCompanySyncChecker/components/CurrentCompanySyncChecker';

export default function EntryPoint({ contextProps }) {
  return (
    <AppWrapper {...contextProps}>
      <QueryClientProvider client={queryClient}>
        <CurrentCompanySyncChecker />
      </QueryClientProvider>
    </AppWrapper>
  );
}
